import { parseExtenstion } from "src/app/core/common";
import { MimeTypesEnum } from "../enums";

export class FilenameHelper {
    private _ext: string = '';
    private _name: string = '';
    private _mimetype: MimeTypesEnum;

    get fullname(): string {
        return `${this._name}${this._ext}`;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get extension(): string {
        return this._ext;
    }

    get mimetype(): MimeTypesEnum {
        return this._mimetype;
    }

    constructor(filename?: string, mimetype?: MimeTypesEnum) {
        if (filename) {
            this.setFilename(filename, mimetype);
        }
    }

    setFilename(filename: string, mimetype?: MimeTypesEnum): void {
        if (mimetype && this.isFolder(mimetype)) {
            this._name = filename;
            this._mimetype = mimetype;
            this._ext = '';
            return;
        }

        const { name, extension } = this.breakFilename(filename);
        this._name = name;
        this._ext = extension;
    }

    replaceFileName(filename: string): void {
        if (!this._ext || !this._name) {
            this.setFilename(filename);
            return;
        }

        const { name, extension } = this.breakFilename(filename);

        if (this._ext && this._ext === extension && name) {
            this._name = name;
        }
    }

    private breakFilename(filename: string): { name: string, extension: string} {
        const extension = parseExtenstion(filename);
        const name = filename.replace(extension, '');

        return { name, extension };
    }

    private isFolder(mimetype: MimeTypesEnum) {
        return mimetype === MimeTypesEnum.Folder || mimetype === MimeTypesEnum.DriveFolder || mimetype === MimeTypesEnum.SharedDrive;
    }
}